<template>
    <footer id="mobile-bottom-navigation">

        <router-link
            v-for="(navigationItem, index) in navigationItems"
            :key="index"
            :to="navigationItem.route"
            class="link-item"
            :data-v-step="navigationItem.type.includes('compare') && isPhone ?'argument-2':''"
            :data-tracking="navigationItem.type.includes('compare') ? 'button__compare' : ''"
            :class="{active: $route.meta.navigationActive === navigationItem.type, 'coming-soon': navigationItem.comingSoon}"
        >
            <span class="icon-container">
                <span :class="[navigationItem.icon, brandColor]"></span>
            </span>
            <h2 class="title" v-html="navigationItem.title"></h2>
            <span class="coming-soon" v-if="navigationItem.comingSoon">{{ navigationItem.subtitle }}</span>
            <span class="bottom-line" :class="brandBackgroundColor"></span>
        </router-link>
    </footer>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        name: 'MobileBottomNavigation',

        computed: {
            ...mapState({
                isPhone: state => state.settings.isPhone,
                navigationItems: state => state.settings.navigationItems
            }),
        },
      beforeCreate : function() {
        this.$forceUpdate();
      }



    }
</script>

<style lang="scss">
    #mobile-bottom-navigation {
        display: none;
        justify-content: space-around;
        width: 100%;
        position: fixed;
        bottom: 0;
        z-index: 10;
        height: $mobile-bottom-navigation;

        @media #{$mq_phone} {
            display: flex;
        }

        .link-item {
            position: relative;
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-align: center;
            background-color: $blackish;
            border-right: 1px solid #515151;

            &:last-child {
                border-right: none;
            }

            &:hover, &.active {
                .bottom-line {
                    opacity: 1;
                }
            }

            &.coming-soon {
              display: none;
            }

            .icon-container {
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 32px;
                height: 32px;
                margin: 0 auto;
                background-color: #333333;
                border-radius: 1000px;


                [class^="icon-"], [class*=" icon-"] {
                    &.icon-search {
                        font-size: 15px;
                    }

                    &.icon-compare {
                        font-size: 17px;
                    }

                    &.icon-formation {
                        margin-top: 4px;
                        font-size: 17px;
                    }
                }
            }

            .title {
                font-weight: 700;
                color: $white;
                margin-top: 10px;
                font-size: 10px;
            }

            .coming-soon {
                font-weight: 700;
                color: #7e7e7e;
                font-size: 10px;
            }

            .bottom-line {
                opacity: 0;
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                height: 7px;
                transition: opacity 0.3s ease;
            }
        }
    }
</style>